import React, { FunctionComponent } from 'react'

import styled from 'styled-components/native'

import calendarOpenSpotsIllustrationUrl from '../../assets/calendarOpenSpots.png'
import { tID } from '../../utils/utils'
import { Image } from '../image/Image'

type CalendarOpenSpotsIllustrationProps = {
  height?: number
  width?: number
  size?: number
}

const ImageContainer = styled(Image)<{ imageHeight: string; imageWidth: string }>(({ imageHeight, imageWidth }) => ({
  height: imageHeight,
  width: imageWidth,
}))

/**
 * Illustration shown on appointment booking confirmation
 */
export const CalendarOpenSpotsIllustration: FunctionComponent<CalendarOpenSpotsIllustrationProps> = ({
  height = 100,
  width = 100,
  size,
}) => {
  const heightInPixels = `${height}px`
  const widthInPixels = `${width}px`
  return (
    <ImageContainer
      imageHeight={size ? `${size}px` : heightInPixels}
      imageWidth={size ? `${size}px` : widthInPixels}
      testID={`${tID('CalendarOpenSpotsIllustration')}`}
      source={calendarOpenSpotsIllustrationUrl}
    />
  )
}
